import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2 mb-1" }
const _hoisted_2 = { class: "mb-3 text-md font-medium pt-2" }
const _hoisted_3 = {
  key: 0,
  class: "text-gray-400 text-sm"
}
const _hoisted_4 = { class: "flex items-center gap-3 mb-3 text-gray-500 text-sm" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = { class: "mt-1" }
const _hoisted_7 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_8 = { class: "mt-1" }
const _hoisted_9 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_10 = { class: "flex flex-wrap gap-2 mt-2" }
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = { class: "mt-1 flex items-center gap-2" }

import { computed, onMounted, watch } from 'vue';
import { useActivitiesStore } from '@/store/activities';
import { useFloatFormStore } from '@/store/floatForm';
import { EVIDENCE_FIELDS } from '@/components/modules/activities/activities.config';
import { EDIT_FORM } from '@/components/modules/activities/activities.config';
import { VTextarea } from 'vuetify/components';

import { format } from 'date-fns';


export default /*@__PURE__*/_defineComponent({
  __name: 'Detail',
  props: {
    id: {}
  },
  emits: ['close', 'edit', 'finish', 'reschedule'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const store = useActivitiesStore();
const floatFormStore = useFloatFormStore();

const loading = computed(() => store.activity === null);

async function fetchActivity() {
  await store.fetchActivityById(props.id);
}

onMounted(fetchActivity);

watch(
  () => props.id,
  async (newId, oldId) => {
    if (newId && newId !== oldId) {
      await fetchActivity();
    }
  }
);

// Computed para los datos a mostrar
const activity = computed(() => store.activity || {}) as any; // Así se vuelve reactivo al cambio en el store

const subjectLabel = computed(() => {
  if (!activity.value?.subject) return '';
  return activity.value.subject.type === 'clients' ? 'Cliente' : 'Lead';
});
const subjectName = computed(() => {
  const attr = activity.value?.subject?.attributes || {};
  return attr.commercial_name || attr.legal_name || '';
});
const responsibleName = computed(() => {
  const u = activity.value?.user || {};
  return [u.name, u.last_name].filter(Boolean).join(' ') || '-';
});
function formatDate(dateStr: string) {
  if (!dateStr) return '-';
  return format(new Date(dateStr), "eee dd 'de' MMMM yyyy, h:mm a", { locale: undefined });
}
function statusColor(status?: string) {
  switch (status) {
    case 'Vencida': return 'red';
    case 'Completada': return 'green';
    case 'Pendiente': return 'orange';
    default: return 'grey';
  }
}
function openEvidence(url: string) {
  window.open(url, '_blank');
}

async function onReschedule() {
  try {
    const REASON_FIELD = {
      value: 'reason',
      label: 'Motivo de Reagendamiento',
      component: VTextarea,
      required: true,
      col: 12,
      rows: 3,
      autoGrow: true,
    };
    const fields = [...EDIT_FORM, REASON_FIELD];
    const formData = await floatFormStore.openFormWithPromise({
      component: 'EditForm',
      formTitle: 'Reagendar Actividad',
      formWidth: 700,
      module: 'Activities',
      props: {
        fields,
        initialValues: { ...activity.value, reason: '' }
      }
    });
    await store.rescheduleActivity(activity.value.id, formData);
    await fetchActivity();
  } catch (e) {
    console.warn('Reagendamiento cancelado o error', e);
  }
}

async function onFinishActivity() {
  try {
    const formData = await floatFormStore.openFormWithPromise({
      component: 'EvidenceForm',
      formTitle: 'Finalizar actividad',
      formWidth: 600,
      props: { fields: EVIDENCE_FIELDS }
    });
    await store.updateActivity(activity.value.id, {
      completed_at: new Date().toISOString().slice(0, 19).replace('T', ' '),
      additional_data: {
        ...(activity.value.additional_data || {}),
        ...formData
      }
    });
    // Actualiza el detalle desde el store
    await fetchActivity();
  } catch (e) {
    console.warn('Cancelado o error', e);
  }
}

function onEditActivity() {
  floatFormStore.openForm({
    component: 'EditForm',
    formTitle: 'Editar actividad',
    formWidth: 800,
    module: 'Activities',
    props: {
      item: activity.value,
      onUpdate: (data: Record<string, any>) => store.updateActivity(data.id, data)
    }
  });
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    flat: "",
    class: "rounded-2xl shadow-xl mx-auto",
    style: {"max-width":"500px","min-width":"340px","margin-top":"40px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "flex items-center gap-3" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "ma-0" }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createVNode(_component_v_icon, {
                    class: "mr-2",
                    size: "26"
                  }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode("mdi-calendar-check")
                    ])),
                    _: 1,
                    __: [1]
                  }),
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "font-semibold text-lg" }, "Detalle de Actividad", -1))
                ]),
                _createElementVNode("div", _hoisted_1, [
                  (activity.value.type)
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 0,
                        color: "primary",
                        size: "small",
                        label: "",
                        class: "mr-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            left: "",
                            size: "16"
                          }, {
                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                              _createTextVNode("mdi-email")
                            ])),
                            _: 1,
                            __: [3]
                          }),
                          _createTextVNode(" " + _toDisplayString(activity.value.type), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (activity.value.status?.name)
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 1,
                        color: statusColor(activity.value.status?.name),
                        size: "small",
                        label: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(activity.value.status?.name), 1)
                        ]),
                        _: 1
                      }, 8, ["color"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                icon: "",
                variant: "text",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                "aria-label": "Cerrar"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createTextVNode("mdi-close")
                    ])),
                    _: 1,
                    __: [4]
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_card_text, { class: "flex flex-col gap-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "ma-0" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createTextVNode(_toDisplayString(subjectName.value) + " ", 1),
                (activity.value.contact)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, "- " + _toDisplayString(activity.value.contact.name), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_v_spacer),
              (activity.value.subject)
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 0,
                    size: "small",
                    variant: "outlined",
                    color: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(subjectLabel.value), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_icon, { size: "18" }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("mdi-clock-outline")
              ])),
              _: 1,
              __: [5]
            }),
            _createTextVNode(" " + _toDisplayString(formatDate(activity.value.date)), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "font-medium text-sm text-gray-500 text-caption" }, "Descripción", -1)),
            _createElementVNode("div", _hoisted_6, _toDisplayString(activity.value.description || 'Sin descripción'), 1)
          ]),
          (activity.value.additional_data?.result)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "font-medium text-sm text-gray-500 text-caption" }, "Resultado", -1)),
                _createElementVNode("div", _hoisted_8, _toDisplayString(activity.value.additional_data.result), 1)
              ]))
            : _createCommentVNode("", true),
          (activity.value.additional_data?.documents?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "font-medium text-sm text-gray-500 text-caption" }, "Evidencias", -1)),
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activity.value.additional_data.documents, (doc, i) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                      (doc.file)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 0,
                            size: "small",
                            color: "success",
                            onClick: ($event: any) => (openEvidence(doc.file)),
                            style: {"cursor":"pointer"},
                            "prepend-icon": "mdi-paperclip"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(doc.label || `Documento ${i+1}`), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "font-medium text-sm text-gray-500 text-caption" }, "Responsable", -1)),
            _createElementVNode("div", _hoisted_12, [
              (activity.value.user?.profile_photo_path)
                ? (_openBlock(), _createBlock(_component_v_avatar, {
                    key: 0,
                    size: "24",
                    class: "mr-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_img, {
                        src: activity.value.user.profile_photo_path
                      }, null, 8, ["src"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(responsibleName.value), 1)
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_card_actions, { class: "flex justify-between gap-2 px-4 py-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            color: "success",
            variant: "tonal",
            size: "small",
            onClick: onFinishActivity,
            disabled: loading.value || activity.value.completed_at
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                left: "",
                size: "18"
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createTextVNode("mdi-check-circle")
                ])),
                _: 1,
                __: [10]
              }),
              _cache[11] || (_cache[11] = _createTextVNode(" Terminar "))
            ]),
            _: 1,
            __: [11]
          }, 8, ["disabled"]),
          _createVNode(_component_v_btn, {
            color: "primary",
            variant: "outlined",
            size: "small",
            onClick: onReschedule,
            disabled: loading.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                left: "",
                size: "18"
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createTextVNode("mdi-calendar-refresh")
                ])),
                _: 1,
                __: [12]
              }),
              _cache[13] || (_cache[13] = _createTextVNode(" Reagendar "))
            ]),
            _: 1,
            __: [13]
          }, 8, ["disabled"]),
          (_ctx.$can('activities.update'))
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                variant: "outlined",
                size: "small",
                onClick: onEditActivity,
                disabled: loading.value
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    left: "",
                    size: "18"
                  }, {
                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                      _createTextVNode("mdi-pencil")
                    ])),
                    _: 1,
                    __: [14]
                  }),
                  _cache[15] || (_cache[15] = _createTextVNode(" Editar "))
                ]),
                _: 1,
                __: [15]
              }, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_v_overlay, {
        "model-value": loading.value,
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            size: "48",
            color: "primary"
          })
        ]),
        _: 1
      }, 8, ["model-value"])
    ]),
    _: 1
  }))
}
}

})